<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="shouldShowBanner"
    class="notification-banner fix-class"
  >
    <b-alert
      v-for="(banner, index) in bannerData"
      :key="index"
      class="alert-container d-flex align-items-center"
      show
      dismissible
      :variant="null"
      @dismissed="bannerClosed(index)"
    >
      <div class="alert-row d-flex align-items-center w-100">
        <feather-icon
          icon="AlertCircleIcon"
          size="22"
          class="alert-icon flex-shrink-0 mr-50"
        />
        <div class="alert-body">
          <p class="notification-subject mb-0">
            <strong>
              {{ banner.subject }}
            </strong>
          </p>
          <div
            class="notification-content"
            :title="getPlainContent(banner.notification_body)"
          >
            <span class="notification-content-text">
              {{ getContentPreview(banner.notification_body) }}
            </span>
          </div>
        </div>
        <b-button
          v-if="banner.notification_body"
          variant="danger"
          class="btn-see-more"
          @click="handleClickForNotice"
        >
          SEE MORE
        </b-button>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessage from '@core/mixins/ErrorMessage'

const bannerRepository = RepositoryFactory.get('banner')
export default {
  components: {
    BAlert,
    BButton,
  },
  mixins: [ErrorMessage],
  data() {
    return {
      bannerData: null,
      isBannnerShown: false,
      isStaff: -1,
      color: '',
      bannerHeight: '5.5em',
    }
  },
  computed: {
    shouldShowBanner() {
      return this.isBannnerShown && (this.$route.name !== 'notices' && this.$route.name !== 'login')
    },
  },
  mounted() {
    this.fetchBannerData()
  },
  methods: {
    closeBtn() {
      this.bannerData.is_banner_alert_active = 0
    },
    hasClickHereLink(content) {
      return content && content.includes('click here')
    },
    getPlainContent(content) {
      if (!content) return ''
      return this.removeHtmlTags(content)
    },
    getContentPreview(content) {
      if (!content) return ''
      const plain = this.getPlainContent(content)
      if (!this.hasClickHereLink(content)) {
        return plain
      }
      return plain.split('click here')[0].trimEnd()
    },
    removeHtmlTags(input) {
      const doc = new DOMParser().parseFromString(input, 'text/html')
      return doc.body.textContent || ''
    },
    async fetchBannerData() {
      try {
        const bannerDataResponse = this.$route.name === 'login' ? await bannerRepository.getActiveBannerNoAuth() : await bannerRepository.getActiveBannerAuth()
        this.bannerData = bannerDataResponse.data.data
        if (this.bannerData && this.bannerData.length > 0) {
          this.isBannnerShown = true
        } else {
          this.isBannnerShown = false
        }
      } catch (fetchError) {
        // Check if error is due to unauthenticated access
        if (fetchError.response && fetchError.response.status === 401 && this.$route.name === 'login') {
          // User is unauthenticated, fetch unauthenticated banner data
          try {
            const unauthBannerDataResponse = await bannerRepository.getActiveBannerNoAuth()
            this.bannerData = unauthBannerDataResponse.data.data
            if (this.bannerData && this.bannerData.length > 0) {
              this.isBannnerShown = true
            } else {
              this.isBannnerShown = false
            }
          } catch (error) {
            // Handle error fetching unauthenticated banner data
            this.convertAndNotifyError(error)
          }
        } else {
          // Handle other errors
          this.convertAndNotifyError(fetchError)
        }
      }
    },
    isExpired(date) {
      const now = new Date()
      return date < now
    },
    bannerClosed(index) {
      this.bannerData.splice(index, 1)
      if (this.bannerData.length === 0) {
        this.isBannnerShown = false
      }
    },
    handleClickForNotice() {
      this.$router.push('/notices')
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

@media (max-width: 600px) {
  .alert-body {
    font-size: 8px;
    height: auto !important;
  }
  .notification-content{
    max-width: 100%;
  }
  .notification-content p{
    line-height: 0.55rem !important;
  }
  .notification-subject{
    word-wrap: break-word;
    white-space: normal;
    max-width: 100%;
    line-height: 0.55rem !important;
  }
}

@media (max-width: 768px) and (min-width: 601px) {
  .alert-body {
    font-size: 10px;
  }
  .notification-content{
    word-wrap: break-word;
    white-space: normal;
    max-width: 100%;
  }
  .notification-content p{
    line-height: 0.75rem !important;
  }
  .notification-subject{
    word-wrap: break-word;
    white-space: normal;
    max-width: 90%;
    line-height: 0.75rem !important;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .alert-body {
    font-size: 10px;
  }
  .notification-content{
    max-width: 100%;
  }
  .notification-content p{
    line-height: 1.25rem !important;
  }
  .notification-subject{
    word-wrap: break-word;
    white-space: normal;
    max-width: 90%;
    line-height: 0.75rem !important;
  }
}
.alert-container {
  background-color: #D936331A;
  padding: 0.5rem 3rem 0.5rem 1rem;
  overflow: hidden;
  max-width: 100%;
  border: 1px solid #B51A1E;
}

.alert-row {
  min-width: 0;
}
.notification-banner {
  text-align: left;
  width: 100%;
  max-width: 100%;
  transition: height 0.3s ease;
  border-radius: 0px;
  align-items: center;
  justify-content: start;
  margin-bottom: 0;
  padding-bottom: 0;
  color: white;
  overflow: hidden;
  box-sizing: border-box;
}

.notification-subject {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  margin-bottom: 5px !important;
  line-height: 1.25rem !important;
  font-size: 1.2rem;
  color: #B51A1E;
}
.alert-body {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}
.notification-content {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  line-height: 1.25rem !important;
  font-size: 1rem;
  color: #434657;
}

.notification-content-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1 1 auto;
}

.notification-content-link {
  flex-shrink: 0;
  margin-left: 0.25rem;
  white-space: nowrap;
}

:root {
  --dark-bg: #1e1e1e;
  --dark-text: #ffffff;
}
.alert.alert-dismissible .close {
  padding: 1.75rem 1rem;
  color: #B51A1E;
  z-index: 1;
}
.fix-class {
  position: relative;
}

.alert-icon {
  color: #B51A1E;
}

.btn-see-more {
  background-color: #AA2F32;
  border-color: #AA2F32;
  color: white;
  padding: 0.4rem 0.8rem;
  font-size: 0.8rem;
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: 15px;
  cursor: pointer;
}
</style>
